export default __webpack_public_path__ + "static/media/Tesla Fast.fe4b8a9a.svg";